import { Button } from "@/components/ui/button";
import { CircleCheck, Home, Link2Off } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDownsellFlow } from "../../context/use-downsell-flow/use-downsell-flow";
export const DownsellResult = () => {
  const navigate = useNavigate();
  const { downsellFlowStatus, errorMessages, downsellData } = useDownsellFlow();

  const isMultipleBookingsCancellation =
    !!downsellData &&
    [
      "booking-and-next-bookings-and-cycles",
      "booking-and-next-bookings",
    ].includes(downsellData.downsell_type);

  const bookingResultMessage = isMultipleBookingsCancellation
    ? "Suas reservas de escritório privativo foram canceladas com sucesso!"
    : "Sua reserva de escritório privativo foi cancelada com sucesso!";

  const renderStatus = () => {
    if (downsellFlowStatus.downsell === "error") {
      return (
        <div className="flex flex-col justify-start items-center gap-4 inline-flex">
          <Link2Off className="h-16 w-16" />
          <div className="h-[73px] flex-col justify-start items-start gap-px inline-flex">
            <div className="self-stretch text-center text-[#08080a] text-2xl font-semibold font-['Inter'] leading-loose">
              Algo deu errado ao realizar downsell de pacotes
            </div>
            <div className="text-center text-zinc-500 text-sm font-normal font-['Inter'] leading-tight">
              Ocorreu um erro durante o processo.
              <br />
              Por favor, verifique sua conexão e tente novamente mais tarde.
            </div>
          </div>
          <p className="text-sm text-gray-500 mt-2">{errorMessages.booking}</p>
        </div>
      );
    }

    if (downsellFlowStatus.downsell === "success") {
      return (
        <div className="flex flex-col justify-start items-center gap-4 inline-flex">
          <CircleCheck className="h-16 w-16" />
          <div className="flex-col justify-start items-center gap-px inline-flex">
            <div className="text-center text-[#08080a] text-2xl font-semibold font-['Inter'] leading-loose">
              Sucesso!
            </div>
            <div className="text-center text-zinc-500 text-sm font-normal font-['Inter'] leading-tight mb-4">
              {bookingResultMessage}
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      {renderStatus()}
      <Button
        className="bg-white text-black border border-[#e3e3e7] justify-center items-center gap-2 inline-flex hover:bg-gray-900 group"
        onClick={() => navigate("/private-office/bookings")}
      >
        <Home className="h-4 w-4 group-hover:text-white transition-colors duration-200" />
        <label className="group-hover:text-white transition-colors duration-200 cursor-pointer">
          Retornar ao início
        </label>
      </Button>
    </div>
  );
};
